import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import NewsOne from "../img/news1.jpg";
import NewsTwo from "../img/news3.jpg";
import Farmer from "../img/SomeGuy_x1440.png";
import FarmerL from "../img/SomeGuy_x1024.png";
import FarmerM from "../img/SomeGuy_x768.png";
const useStyles = makeStyles((theme) => ({
  borderBox: {
    width: "100%",
    height: "100%",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "5px",

    padding: "20px",
    [theme.breakpoints.between("lm", "lm")]: {
      padding: "15px 10px",
    },
  },

  contentTitle: {
    color: "black",
    marginBottom: "15px",
  },
  imgageBox: {
    width: "90%",
    height: "auto",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    backgroundColor: "white",
    position: "relative",
    zIndex: 5,
    padding: "20px 0",
    paddingLeft: "60px",
    paddingRight: "85px",
    [theme.breakpoints.between("lm", "lm")]: {
      padding: "15px 0",
      paddingLeft: "50px",
      paddingRight: "65px",
    },
    [theme.breakpoints.between("md", "md")]: {
      padding: "15px 0",
      paddingLeft: "40px",
      paddingRight: "55px",
    },
  },
  imgNews: {
    width: "100%",
    height: "auto",
    marginBottom: "35px",
    zIndex: 100,
    [theme.breakpoints.between("md", "md")]: {
      marginBottom: "20px",
    },
  },
  farmer: {
    position: "absolute",
    right: "-200px",
    top: "-150px",
    zIndex: -5,
    [theme.breakpoints.between("lm", "lm")]: {
      right: "-100px",
      top: "-100px",
    },
    [theme.breakpoints.between("md", "md")]: {
      right: "-80px",
      top: "-80px",
    },
  },
}));
export default function MainContent({ tabButton }) {
  const classes = useStyles();

  return (
    <Box className={classes.borderBox}>
      {tabButton === 1 ? (
        <ImgBox />
      ) : (
        <Typography variant="h2" className={classes.contentTitle}>
          コンテンツの更新中
        </Typography>
      )}
    </Box>
  );
}

const ImgBox = () => {
  const classes = useStyles();
  return (
    <Box>
      <Typography variant="h2" className={classes.contentTitle}>
        今月の産直野菜
      </Typography>

      <Box className={classes.imgageBox}>
        <img src={NewsOne} alt="NEWS" className={classes.imgNews} />{" "}
        <img src={NewsTwo} alt="NEWS" className={classes.imgNews} />
        <picture>
          <source
            media="(min-width: 768px) and (max-width:1023px)"
            srcSet={FarmerM}
          />
          <source
            media="(min-width: 1024px) and (max-width:1439px)"
            srcSet={FarmerL}
          />
          <img src={Farmer} alt="farmer" className={classes.farmer} />{" "}
        </picture>
      </Box>
    </Box>
  );
};
